import React from 'react'
import { Grid, Typography, useTheme } from '@material-ui/core'
import { colors } from 'theme'

const Header = ({ header, subheader }) => {
  const theme = useTheme()
  if (!header) return null

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      style={{
        padding: theme.spacing(5, 2),
        backgroundColor: colors.navyblue,
        marginTop: theme.spacing(-2),
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        color="secondary"
        align="center"
        style={{ fontSize: 34 }}
      >
        {header}
      </Typography>
      {subheader && (
        <Typography
          variant="h5"
          component="h2"
          color="secondary"
          align="center"
          style={{ marginTop: theme.spacing(2), opacity: 0.6 }}
        >
          {subheader}
        </Typography>
      )}
    </Grid>
  )
}

export default Header
